export var FeatureToggle;
(function (FeatureToggle) {
    FeatureToggle["OrderAgain"] = "orderAgain";
    FeatureToggle["Catering"] = "catering";
})(FeatureToggle || (FeatureToggle = {}));
//# sourceMappingURL=types.js.map